/**
 * @flow
 * @relayHash e19ede3d563d21ba16edc36179b8028b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ArticleListItem_article$ref = any;
export type UserStats_QueryVariables = {|
  userId: string,
  page?: ?number,
|};
export type UserStats_QueryResponse = {|
  +viewer: ?{|
    +me: ?{|
      +id: string,
      +canDelete: ?boolean,
    |},
    +articles: ?{|
      +totalCount: ?number,
      +articles: ?$ReadOnlyArray<?{|
        +$fragmentRefs: ArticleListItem_article$ref
      |}>,
    |},
  |}
|};
export type UserStats_Query = {|
  variables: UserStats_QueryVariables,
  response: UserStats_QueryResponse,
|};
*/


/*
query UserStats_Query(
  $userId: ID!
  $page: Int
) {
  viewer {
    me {
      id
      canDelete
    }
    articles: articlesPaginate(pageSize: 15, page: $page, user: $userId) {
      totalCount
      articles {
        ...ArticleListItem_article
        id
      }
    }
    id
  }
}

fragment ArticleListItem_article on Article {
  id
  section
  title
  authorName
  categoryName
  availableAt
  hidden
  isArticleOfDay
  isArticleOfHour
  isEvent
  state
  mainPageOrder
  showInYandexNews
  showInYandexZen
  infostring
  infostring_hot
  mediaFiles {
    id
  }
  preview {
    type
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "me",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canDelete",
      "args": null,
      "storageKey": null
    }
  ]
},
v3 = [
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page",
    "type": "Int"
  },
  {
    "kind": "Literal",
    "name": "pageSize",
    "value": 15,
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "user",
    "variableName": "userId",
    "type": "ID"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "UserStats_Query",
  "id": null,
  "text": "query UserStats_Query(\n  $userId: ID!\n  $page: Int\n) {\n  viewer {\n    me {\n      id\n      canDelete\n    }\n    articles: articlesPaginate(pageSize: 15, page: $page, user: $userId) {\n      totalCount\n      articles {\n        ...ArticleListItem_article\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ArticleListItem_article on Article {\n  id\n  section\n  title\n  authorName\n  categoryName\n  availableAt\n  hidden\n  isArticleOfDay\n  isArticleOfHour\n  isEvent\n  state\n  mainPageOrder\n  showInYandexNews\n  showInYandexZen\n  infostring\n  infostring_hot\n  mediaFiles {\n    id\n  }\n  preview {\n    type\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserStats_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": "articles",
            "name": "articlesPaginate",
            "storageKey": null,
            "args": v3,
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ArticleListItem_article",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UserStats_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": "articles",
            "name": "articlesPaginate",
            "storageKey": null,
            "args": v3,
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "section",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "authorName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "categoryName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hidden",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isArticleOfDay",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isArticleOfHour",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isEvent",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "mainPageOrder",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showInYandexNews",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showInYandexZen",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "infostring",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "infostring_hot",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaFiles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaFile",
                    "plural": true,
                    "selections": [
                      v1
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "preview",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaFile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      v1
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c7a7d6ad1b3f98e9443f197e4b9c5f9f';
module.exports = node;



// WEBPACK FOOTER //
// src/components/stats/__generated__/UserStats_Query.graphql.js